var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / SG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-SG",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#E12237",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66666667,1.33333333 C7.61178022,1.33333333 8.48033641,1.66111433 9.16485679,2.20919786 C8.80218128,2.07392284 8.40972344,2 8,2 C6.15905083,2 4.66666667,3.49238417 4.66666667,5.33333333 C4.66666667,7.1742825 6.15905083,8.66666667 8,8.66666667 C8.40972344,8.66666667 8.80218128,8.59274382 9.16476382,8.45750783 C8.48033641,9.00555234 7.61178022,9.33333333 6.66666667,9.33333333 C4.45752767,9.33333333 2.66666667,7.54247233 2.66666667,5.33333333 C2.66666667,3.12419433 4.45752767,1.33333333 6.66666667,1.33333333 Z M8.66666667,6.66666667 C9.0348565,6.66666667 9.33333333,6.9651435 9.33333333,7.33333333 C9.33333333,7.70152317 9.0348565,8 8.66666667,8 C8.29847683,8 8,7.70152317 8,7.33333333 C8,6.9651435 8.29847683,6.66666667 8.66666667,6.66666667 Z M11.3333333,6.66666667 C11.7015232,6.66666667 12,6.9651435 12,7.33333333 C12,7.70152317 11.7015232,8 11.3333333,8 C10.9651435,8 10.6666667,7.70152317 10.6666667,7.33333333 C10.6666667,6.9651435 10.9651435,6.66666667 11.3333333,6.66666667 Z M7.33333333,4 C7.70152317,4 8,4.29847683 8,4.66666667 C8,5.0348565 7.70152317,5.33333333 7.33333333,5.33333333 C6.9651435,5.33333333 6.66666667,5.0348565 6.66666667,4.66666667 C6.66666667,4.29847683 6.9651435,4 7.33333333,4 Z M12.6666667,4 C13.0348565,4 13.3333333,4.29847683 13.3333333,4.66666667 C13.3333333,5.0348565 13.0348565,5.33333333 12.6666667,5.33333333 C12.2984768,5.33333333 12,5.0348565 12,4.66666667 C12,4.29847683 12.2984768,4 12.6666667,4 Z M10,2 C10.3681898,2 10.6666667,2.29847683 10.6666667,2.66666667 C10.6666667,3.0348565 10.3681898,3.33333333 10,3.33333333 C9.63181017,3.33333333 9.33333333,3.0348565 9.33333333,2.66666667 C9.33333333,2.29847683 9.63181017,2 10,2 Z",
    id: "Oval-12",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSg);
export default __webpack_public_path__ + "static/media/SG.b083d08aa9458e9244d3141763991640.svg";
export { ForwardRef as ReactComponent };